import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../../components/Layout';

export default function Contact() {
  const { t: translate } = useTranslation();
  return (
    <Layout>
      <div>
        <h1>{translate('contact.title')}</h1>
      </div>
    </Layout>
  );
}
